import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import "./Chat.less";
import imgImg from "@/assets/images/send-img.png";
import msgImg from "@/assets/images/send-msg.png";
import { getClientApi, getMessageListApi, putClientApi } from "@/services/YsApi/messageManage";
import dayjs from "dayjs";
import { Button, Descriptions, Form, Input, Message, Select, Spin, Tooltip } from "@arco-design/web-react";
import {
  IconEdit,
  IconExclamationCircleFill,
  IconQuestionCircleFill,
} from "@arco-design/web-react/icon";
import { v4 as uuidv4 } from "uuid";
import Modals from "@/components/Modals";
export function isToday(date) {
  const today = dayjs().startOf("day"); // 今天的开始时间
  const otherDay = dayjs(date).startOf("day"); // 需要判断的时间的开始时间
  return today.isSame(otherDay); // 比较是否相同
}
export function isYesterday(date) {
  const today = dayjs().subtract(1, "day").startOf("day"); // 昨天的开始时间
  const otherDay = dayjs(date).startOf("day"); // 需要判断的时间的开始时间
  return today.isSame(otherDay); // 比较是否相同
}
function isMoreThan30(time1, time2) {
  const dt1 = dayjs(time1);
  const dt2 = dayjs(time2);

  // 计算两个时间之间的分钟数差
  const minutesDiff = dt2.diff(dt1, "minutes");
  return Math.abs(minutesDiff) > 30;
}
function pushTimeArray(array, time) {
  if (isToday(time)) {
    array.push({ type: "time", value: dayjs(time).format("HH:mm") });
  } else if (isYesterday(time)) {
    array.push({ type: "time", value: "昨天" + dayjs(time).format("HH:mm") });
  } else {
    array.push({ type: "time", value: dayjs(time).format("YYYY-MM-DD HH:mm") });
  }
}
function ZxEllipsis({ children }) {
  return (
    <Tooltip content={children} color="#1890ff" getPopupContainer={() => document.body}>
      <div className="zx-ellipsis">
        {children || '--'}
      </div>
    </Tooltip>
  )
}
const validatePhoneNumber = (value, callback) => {
  const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
  if (value && !regex.test(value)) {
    callback(<div>请输入正确的手机号码</div>);
  } else {
    callback();
  }
};
function Chat(
  {
    conversitionObj,
    authData,
    socket,
    sessionList,
    onChangeSessionStatus,
    onRefreshSessionList,
    onRefreshAccountList,
    canSend
  }: any,
  ref,
) {
  const srcollRef = useRef<any>(null);
  const pageRef = useRef(1);
  const [messageList, setMessageList] = useState([]);
  const [total, setTotal] = useState(0);
  const authDataRef = useRef<any>({});
  const sessionListRef = useRef<any>([]);
  const conversitionObjRef = useRef<any>({});
  const messageListRef = useRef<any>([]);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [moreLoading, setMoreLoading] = useState(false);
  const [retryVisible, setRetryVisible] = useState(false);
  const [retryObj, setRetryObj] = useState<any>({});
  const retryObjRef = useRef<any>({});
  const [tipVisible, setTipVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false)
  const onTextChange = (e) => {
    setValue(e.target.value);
  };
  const onKeyDown = (e) => {
    if (!value.trim()) return;
    if (!conversitionObj.conversation_id) return;
    const uuid = uuidv4();
    if (e.key === "Enter") {
      if (socket.isConnecting()) {
        socket.send(
          JSON.stringify({
            message_id: uuid,
            account_id: Number(authDataRef.current.account_id),
            conversation_id: conversitionObjRef.current.conversation_id,
            text: value.trim(),
            third_uuid: authDataRef.current.third_uuid
          }),
        );
      }
      setValue("");
      setMessageList([
        {
          uuid: uuid,
          conversation_id: conversitionObjRef.current?.conversation_id,
          sender_id: authDataRef.current.third_uuid,
          message: value.trim(),
          created_at: Date.now() / 1000,
          updated_at: Date.now() / 1000,
          status: socket.isConnecting() ? 2 : 1,
        },
        ...messageListRef.current,
      ]);
      setTimeout(() => {
        srcollRef.current.scrollTop = srcollRef.current.scrollHeight;
      }, 0);
    }
  };
  const handleClickSend = () => {
    onKeyDown({ key: "Enter" });
  };
  const handleReceive = useCallback((obj) => {
    console.log(obj, conversitionObjRef.current, 'sssddddddddss')
    // if (obj.to_user_id == conversitionObjRef.current.from_user_id) return
    // 如果是当前抖音账号
    // if (authDataRef.current?.third_uuid === obj.to_user_id) {
    // 如果当前会话列表有这个会话id
    if (
      sessionListRef.current?.some(
        (item) => item.conversation_id === obj.conversation_id,
      )
    ) {
      // 如果恰好是当前active会话
      if (
        conversitionObjRef.current?.conversation_id ===
        obj.conversation_id
      ) {
        // 忽略掉自己发的消息
        if (messageListRef.current?.some(i => i.uuid == obj.client_message_id)) return;
        setMessageList([
          {
            uuid: obj.client_message_id,
            conversation_id: conversitionObjRef.current?.conversation_id,
            sender_id: obj.from_user_id,
            message: obj.text,
            created_at: obj.create_time / 1000,
            updated_at: obj.create_time / 1000,
          },
          ...messageListRef.current,
        ]);
        onChangeSessionStatus(obj.conversation_id, {
          last_message: obj.text,
          last_message_time: obj.create_time,
        });
        socket.send(
          JSON.stringify({
            type: "read",
            data: {
              conversation_id: conversitionObjRef.current?.conversation_id,
              from_user_id: conversitionObjRef.current?.from_user_id
            },
          }),
        );
        setTimeout(() => {
          srcollRef.current.scrollTop = srcollRef.current.scrollHeight;
        }, 0);
      } else {
        // 如果只是会话列表有这个会话id不等于当前active会话
        // 手动修改会话状态为未读
        onChangeSessionStatus(obj.conversation_id, {
          status: 1,
          last_message: obj.text,
          last_message_time: obj.create_time,
        });
        onRefreshAccountList(obj.to_user_id.toString())
      }
    } else {
      // 如果当前列表没有这个会话 刷新会话列表
      onRefreshSessionList();
      onRefreshAccountList(obj.to_user_id.toString())
    }
    // }
  }, [socket]);
  const handleMore = () => {
    pageRef.current++;
    setMoreLoading(true);
    getMessageListApi({
      page: pageRef.current,
      page_size: 20,
      conversation_id: conversitionObj.conversation_id,
    }).then((res) => {
      setMoreLoading(false);
      setMessageList([...messageList, ...(res.data?.items || [])]);
      setTotal(res.data?.total || 0);
    });
  };
  useEffect(() => {
    console.log(conversitionObj, 'conversitionObj')
    authDataRef.current = authData;
    sessionListRef.current = sessionList;
    conversitionObjRef.current = conversitionObj;
    messageListRef.current = messageList;
  }, [authData, sessionList, conversitionObj, messageList]);
  const [form] = Form.useForm()
  const renderList = useMemo(() => {
    const array = [];
    if (messageList.length) {
      const list = [...messageList];
      list.reverse();
      const first_created_at = list[0].created_at * 1000;
      pushTimeArray(array, first_created_at);
      list.forEach((item, index) => {
        if (index) {
          if (
            isMoreThan30(
              list[index - 1].created_at * 1000,
              item.created_at * 1000,
            )
          ) {
            pushTimeArray(array, item.created_at * 1000);
          }
        }
        array.push(item);
      });
    }
    return array;
  }, [messageList]);
  const reset = () => {
    pageRef.current = 1;
    setMessageList([]);
    setTotal(0);
  };
  const handleMsg = (obj) => {
    const cloneList = JSON.parse(JSON.stringify(messageListRef.current));
    let deleteIndex = -1; // -1不删
    cloneList.forEach((item, index) => {
      if (item.uuid === obj.messageId && !item.retry) {
        item.status = obj.status;
        item.error_msg = obj.status === 1 ? obj.errorMsg : "";
        if (obj.status === 0) {
          onChangeSessionStatus(item.conversation_id, {
            last_message: item.message,
            last_message_time: item.created_at * 1000,
          });
        }
      } else if (item.uuid === obj.messageId && item.retry) {
        // 如果是重新发送 需要删除之前的记录
        deleteIndex = index;
      }
    });
    if (deleteIndex > -1) {
      cloneList.splice(deleteIndex, 1);
      cloneList.unshift({
        conversation_id: conversitionObjRef.current?.conversation_id,
        sender_id: authDataRef.current.third_uuid,
        message: retryObjRef.current.message,
        created_at: Date.now() / 1000,
        updated_at: Date.now() / 1000,
        status: obj.status,
        error_msg: obj.status === 1 ? obj.errorMsg : "",
      });
      if (obj.status === 0) {
        onChangeSessionStatus(conversitionObjRef.current?.conversation_id, {
          last_message: retryObjRef.current.message,
          last_message_time: Date.now(),
        });
      }
    }
    setMessageList(cloneList);
  };
  const handleRetry = (row) => {
    retryObjRef.current = row;
    setRetryObj(row);
    setRetryVisible(true);
  };
  const handleOk = () => {
    if (socket.isConnecting()) {
      socket.send(
        JSON.stringify({
          message_id: retryObj.uuid,
          account_id: Number(authDataRef.current.account_id),
          conversation_id: conversitionObjRef.current.conversation_id,
          text: retryObj.message,
          third_uuid: authDataRef.current.third_uuid
        }),
      );
      const cloneList = JSON.parse(JSON.stringify(messageList));
      cloneList.forEach((i) => {
        if (i.uuid === retryObj.uuid) {
          i.status = 2;
          i.retry = true;
        }
      });
      setMessageList(cloneList);
    } else {
      Message.error("网络已断连");
    }
    setRetryVisible(false);
  };
  useImperativeHandle(ref, () => {
    return {
      appendMessage(obj) {
        setMessageList([obj, ...messageListRef.current]);
        setTimeout(() => {
          srcollRef.current.scrollTop = srcollRef.current.scrollHeight;
        }, 0);
      },
    };
  });
  useEffect(() => {
    if (conversitionObj.conversation_id) {
      setLoading(true);
      reset();
      getMessageListApi({
        page: 1,
        page_size: 20,
        conversation_id: conversitionObj.conversation_id,
      }).then((res) => {
        setLoading(false);
        setMessageList(res.data?.items || []);
        setTotal(res.data?.total || 0);
        setTimeout(() => {
          srcollRef.current.scrollTop = srcollRef.current.scrollHeight;
        }, 0);
      });
    } else {
      reset();
    }
  }, [conversitionObj.conversation_id]);
  useEffect(() => {
    if (JSON.stringify(socket) !== '{}') socket?.onmessage((e) => {
      const obj = JSON.parse(e.data);
      if (obj.conversation_type === 1) {
        handleReceive(obj);
      } else if (obj?.messageId) {
        handleMsg(obj);
      }
    });
  }, [socket]);
  const [editData, setEditData] = useState({
    status: 0,
    phone: '',
    company_name: '',
    remark: ''
  })
  const options = [{ label: '已跟进', value: 1 }, { label: '无意向', value: 2 }, { label: '高意向', value: 3 }, { label: '已成交', value: 4 }, { label: '已电联', value: 5 }]
  const data = [
    {
      label: '状态',
      value: <ZxEllipsis>{options.find(i => i.value === editData.status)?.label || ''}</ZxEllipsis>,
    },
    {
      label: '电话',
      value: <ZxEllipsis>{editData.phone}</ZxEllipsis>,
    },
    {
      label: '公司',
      value: <ZxEllipsis>{editData.company_name}</ZxEllipsis>,
    },
    {
      label: '备注',
      value: <ZxEllipsis>{editData.remark}</ZxEllipsis>,
    },
  ];
  const [editLoading, setEditLoading] = useState(false)
  const handleEdit = () => {
    setEditVisible(true)
    form.setFieldsValue(editData)
  }
  const handleUpdate = () => {
    form.validate().then(formData => {
      setEditLoading(true)
      putClientApi({
        from_user_id: conversitionObj.from_user_id,
        to_user_id: conversitionObj.to_user_id,
        ...formData
      }).then(() => {
        setEditData(formData)
        setEditVisible(false)
        form.resetFields()
      }).finally(() => {
        setEditLoading(false)
      })
    })
  }
  const cancelEdit = () => {
    form.resetFields()
    setEditVisible(false)
  }
  // useEffect(() => {
  //   if (conversitionObj.from_user_id && conversitionObj.to_user_id) {
  //     getClientApi({
  //       from_user_id: conversitionObj.from_user_id,
  //       to_user_id: conversitionObj.to_user_id
  //     }).then(res => {
  //       console.log(res, 'res')
  //       setEditData(res.data?.item || {})
  //     })
  //   }
  // }, [conversitionObj])
  return (
    <div className="message-chat-index">
      <div className="chat-index-header">
        <div className="chat-header-left">
          {conversitionObj.avatar ? <img src={conversitionObj.avatar} alt="" /> : null}
          <span>{conversitionObj.nick_name}</span>
        </div>
        <div className="chat-desc-position">
          {/* 私信须知 */}
          {/* <IconQuestionCircleFill
            onClick={() => setTipVisible(true)}
            style={{ fontSize: "18px", marginLeft: "2px", cursor: "pointer" }}
          /> */}
          {/* {
            conversitionObj.avatar ? <>
              <Descriptions colon=' :' column={2} title={null} data={data} style={{ marginBottom: '-10px' }} />
              <div className="edit">
                <IconEdit onClick={handleEdit} />
              </div></> : null
          } */}
        </div>
      </div>
      <Spin loading={loading} style={{ width: "100%" }}>
        <div className="chat-index-content" ref={srcollRef} style={{ height: 'calc(100vh - 269px)' }}>
          {messageList.length < total && (
            <div className="chat-time">
              {moreLoading ? (
                <Spin />
              ) : (
                <div
                  className="chat-time-box"
                  onClick={handleMore}
                  style={{ cursor: "pointer" }}>
                  查看更多
                </div>
              )}
            </div>
          )}
          {renderList.map((item, index) => {
            if (item.type) {
              return (
                <div className="chat-time" key={index}>
                  <div className="chat-time-box">{item.value}</div>
                </div>
              );
            } else {
              const isMy = authData.third_uuid == item.sender_id;
              return (
                <div
                  className={`his-item ${isMy ? "my-item" : ""}`}
                  key={index}>
                  <div className="his-avatar">
                    <img
                      src={isMy ? authData.avatar : conversitionObj.avatar}
                      alt=""
                    />
                  </div>
                  <div className="his-content">{item.message || '不支持的消息类型'}</div>
                  {item.status ? (
                    <div style={{ lineHeight: "38px", marginRight: "5px" }}>
                      {item.status === 2 && <Spin></Spin>}
                      {item.status === 1 && (
                        <Tooltip
                          content={
                            item.error_msg ? item.error_msg.includes('SEND_MESSAGE_STATUS_INVALID_PARAM_ECODES') ? "授权已过期,消息发送失败" : item.error_msg : '网络错误'
                          }>
                          <IconExclamationCircleFill
                            style={{ color: "red" }}
                            onClick={() => handleRetry(item)}
                          />
                        </Tooltip>
                      )}
                    </div>
                  ) : null}
                </div>
              );
            }
          })}
        </div>
      </Spin>
      <div className="chat-index-bottom">
        <div className="chat-input-wrapper">
          <div className="chat-input">
            <input
              type="text"
              value={value}
              onChange={onTextChange}
              onKeyDown={onKeyDown}
              maxLength={1000}
              disabled={!conversitionObj.conversation_id || !canSend}
            />
          </div>
          <div className="send-btn" style={{ cursor: conversitionObj.conversation_id ? 'pointer' : 'no-drop' }}>
            {
              // value ? <img src={msgImg} alt="" style={{cursor: 'pointer'}} onClick={handleClickSend} /> :
              // <img src={imgImg} alt="" />
              <img
                src={msgImg}
                alt=""
                onClick={handleClickSend}
              />
            }
          </div>
        </div>
      </div>
      <Modals
        visible={retryVisible}
        title="重新发送"
        showFooter
        cancelBtn={<Button onClick={() => setRetryVisible(false)}>取消</Button>}
        handleCancel={() => setRetryVisible(false)}
        subMiteBtn={
          <Button type="primary" onClick={handleOk}>
            确认
          </Button>
        }>
        <div style={{ textAlign: "center", padding: "10px" }}>
          消息发送失败，重新发送该条消息吗?
        </div>
      </Modals>
      <Modals
        visible={editVisible}
        title="留资编辑"
        showFooter
        cancelBtn={<Button onClick={cancelEdit}>取消</Button>}
        handleCancel={cancelEdit}
        subMiteBtn={
          <Button type="primary" onClick={handleUpdate} loading={editLoading}>
            确认
          </Button>
        }>
        <div style={{ padding: '10px 16px 0 16px' }}>
          <Form layout="vertical" form={form}>
            <Form.Item label="状态" field="status" rules={[{ required: true, message: '请选择状态' }]} style={{ marginBottom: '14px' }}>
              <Select placeholder="请选择状态" options={options} />
            </Form.Item>
            <Form.Item label="电话" field="phone" rules={[{ validator: validatePhoneNumber }]} style={{ marginBottom: '14px' }}>
              <Input placeholder="请输入电话号码"></Input>
            </Form.Item>
            <Form.Item label="公司" field="company_name" style={{ marginBottom: '14px' }}>
              <Input placeholder="请输入公司名称" maxLength={20} showWordLimit></Input>
            </Form.Item>
            <Form.Item label="备注" field="remark" style={{ marginBottom: '14px' }}>
              <Input.TextArea rows={4} maxLength={50} showWordLimit></Input.TextArea>
            </Form.Item>
          </Form>
        </div>
      </Modals>
      <Modals
        visible={tipVisible}
        title="私信须知"
        showFooter
        footer={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button onClick={() => setTipVisible(false)} type="primary">
              我知道了
            </Button>
          </div>
        }
        handleCancel={() => setTipVisible(false)}>
        <div style={{ padding: "10px 16px" }}>
          <div>1、因抖音限制，当上条消息已经超过24小时，无法回复;</div>
          <div>2、消息文字长度不得超过1000字，建议100字以内；</div>
        </div>
      </Modals>
    </div>
  );
}

export default forwardRef(Chat);
